import  React from 'react';
import './error-codes.css'

const errorCodesTable = (props) => {
    return(
        <table className="tb-errors">
            <thead>
                <tr>
                    <td colSpan="2">STATUS CODE SUMMARY</td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>200 - OK	</td>
                    <td>Everything worked as expected.</td>
                </tr>
                <tr>
                    <td>400 - Bad Request	</td>
                    <td>The request was unacceptable, often due to missing a required parameter.</td>
                </tr>
                <tr>
                    <td>401 - Unauthorized	</td>
                    <td>No valid API key provided.</td>
                </tr>
                <tr>
                    <td>402 - Request Failed	</td>
                    <td>The parameters were valid but the request failed.</td>
                </tr>
                <tr>
                    <td>403 - Forbidden	</td>
                    <td>The API key doesn't have permissions to perform the request.</td>
                </tr>
                <tr>
                    <td>404 - Not Found	</td>
                    <td>The requested resource doesn't exist.</td>
                </tr>
                {/* <tr>
                    <td>409 - Conflict	</td>
                    <td>The request conflicts with another request (perhaps due to using the same idempotent key).</td>
                </tr> */}
                <tr>
                    <td>429 - Too Many Requests</td>
                    <td>	Too many requests hit the API too quickly. We recommend an exponential backoff of your requests.</td>
                </tr>
                <tr>
                    <td>500, 502, 503, 504 - Server Errors	</td>
                    <td>Something went wrong on Performnance Learning's end. (rarely happens)</td>
                </tr>
            </tbody>
        </table>
    )
}

export default errorCodesTable;